var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Select',{attrs:{"name":_vm.name,"options":_vm.types,"placeholder":_vm.placeholder,"reduce":item => item.value,"searchable":true,"rules":_vm.rules},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }